import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { useRoles } from '../../contexts/RolesContext';
import { useToast } from '../../contexts/ToastContext';
import { ErrorPage } from '../errorPage';
import { HeaderDisplay } from '../headerDisplay';
import { Layout } from '../layout';
import { OfferPosterModal } from '../offerPosterModal';
import { MyView } from './MyView';

export const PersonalOffer = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [displaySnackBar, setDisplaySnackBar] = useState(false);
  const [posterModal, setPosterModal] = useState(false);

  const { hasRoleVisualization } = useRoles();

  useEffect(() => {
    if (location.state) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setDisplaySnackBar(location.state.displaySnackBar);
    }
  }, [location]);

  const { addToast } = useToast();

  useEffect(() => {
    if (displaySnackBar) {
      addToast(
        t('mass-edit.snackbar-success'),
        'success',
        4500,
        'personal-offer_snackbar',
      );
    }
  }, [displaySnackBar]);

  return (
    <Layout>
      <div className="vtmn-w-full vtmn-flex vtmn-flex-col">
        {hasRoleVisualization ? (
          <>
            <OfferPosterModal
              modalStatus={posterModal}
              setModalStatus={setPosterModal}
            />
            <HeaderDisplay />
            <MyView openPosterModal={() => setPosterModal(true)} />
          </>
        ) : (
          <ErrorPage
            errorPageTitle={t('no-access-page.title')}
            errorMessage={t('no-access-page.subtitle')}
          />
        )}
      </div>
    </Layout>
  );
};
